import type { ReactNode } from 'react';
import { Droplet } from './Icons';

/** The large identity banner shown atop every module page (except the cockpit). */
export function PageBanner({ children }: { children?: ReactNode }) {
  return (
    <div className="card mb-6 flex items-center gap-4 p-5">
      <Droplet size={52} />
      <div>
        <div className="text-[19px] font-bold text-slate-800">湖北省农科院循环水吊水养殖科研基地</div>
        <div className="mt-0.5 text-[13px] text-slate-500">循环水吊养 · 智能监控与管理系统</div>
      </div>
      {children}
    </div>
  );
}
